import { SImage } from './styled';

type ImageProps = {
  alt?: string;
  src: string;
};

export const Image = ({ alt, src }: ImageProps) => <SImage alt={alt} src={src} />;
